import React from "react";
import { Form } from "antd";
import TableSearchState from "@/scenes/OrderManagement/redux/states/TableSearchState";
import { FormInstance } from "antd";
import { Select } from "./BaseSelect";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";
import { useGlobalStore } from "@/store/hooks";

interface ConsigneeAreaFieldProps {
    form: FormInstance<TableSearchState>;
}

const ConsigneeAreaField: React.FC<ConsigneeAreaFieldProps> = function (props) {
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();

    function handleProvinceChange() {
        orderManagementStore.table.form.setFieldsValue({ cityCode: "", districtCode: "" });
    }

    function handleCityChange() {
        orderManagementStore.table.form.setFieldsValue({ districtCode: "" });
    }

    return (
        <>
            <Form.Item label={<span className="search-field-label">收货省份</span>} name="provinceCode" initialValue="">
                <Select
                    showSearch={{
                        optionFilterProp: "label",
                    }}
                    onChange={handleProvinceChange}
                    onOpenChange={globalStore.areaStore.ensureFhyArea}
                    options={[
                        {
                            value: "",
                            label: "- 选择省份 -",
                        },
                        ...(globalStore.areaStore.fhyAreas.map((province) => {
                            const { id, name } = province;
                            return {
                                value: id,
                                key: id,
                                label: name,
                            };
                        }) ?? []),
                    ]}
                />
            </Form.Item>
            <Form.Item<TableSearchState> noStyle shouldUpdate={(prev, next) => prev.provinceCode !== next.provinceCode}>
                {(form) => {
                    function getCityOptions() {
                        const { provinceCode } = form.getFieldsValue();
                        if (!provinceCode) return null;

                        const cities = globalStore.areaStore.fhyAreaMap.get(Number(provinceCode))?.children;

                        if (cities?.length) {
                            return cities.map((city) => {
                                const { id, name } = city;

                                return { value: id, key: id, label: name };
                            });
                        }
                    }

                    return (
                        <Form.Item
                            label={<span className="search-field-label">收货城市</span>}
                            name="cityCode"
                            initialValue=""
                        >
                            <Select
                                showSearch={{
                                    optionFilterProp: "label",
                                }}
                                onChange={handleCityChange}
                                options={[
                                    {
                                        value: "",
                                        label: "- 选择城市 -",
                                    },
                                    ...(getCityOptions() ?? []),
                                ]}
                            />
                        </Form.Item>
                    );
                }}
            </Form.Item>
            <Form.Item<TableSearchState> noStyle shouldUpdate={(prev, next) => prev.cityCode !== next.cityCode}>
                {(form) => {
                    function getDistrictOptions() {
                        const { cityCode } = form.getFieldsValue();

                        if (!cityCode) return null;

                        const districts = globalStore.areaStore.fhyAreaMap.get(Number(cityCode))?.children;

                        if (districts?.length) {
                            return districts.map((district) => {
                                const { id, name } = district;

                                return { value: id, key: id, label: name };
                            });
                        }
                    }

                    return (
                        <Form.Item
                            label={<span className="search-field-label">收货区县</span>}
                            name="districtCode"
                            initialValue=""
                        >
                            <Select
                                showSearch={{
                                    optionFilterProp: "label",
                                }}
                                options={[
                                    {
                                        value: "",
                                        label: "- 选择区县 -",
                                    },
                                    ...(getDistrictOptions() ?? []),
                                ]}
                            />
                        </Form.Item>
                    );
                }}
            </Form.Item>
        </>
    );
};

export default observer(ConsigneeAreaField);
